import { useId } from 'react';
import { Collapse } from 'react-bootstrap';

import './style.scss';
import { FormattedMessage } from 'react-intl';
import { trackSmartQuoteEvent } from 'routes/smart-quote/utils';
import { useLocalStorage } from 'usehooks-ts';

import { ChatCard } from './chat-card';
import { CopyCard } from './copy-card';
import { DragDropCard } from './drag-drop-card';

export function QuickStart() {
  const [opened, setOpened] = useLocalStorage('smart-quote-quick-start-opened', true);
  const collapseId = useId();

  const toggle = () => setOpened(prev => !prev);

  const handleHeaderToggle = () => {
    toggle();
    if (!opened) {
      trackSmartQuoteEvent('quick start', 'expand');
    } else {
      trackSmartQuoteEvent('quick start', 'collapse - header');
    }
  };

  const handleDismissToggle = () => {
    toggle();
    trackSmartQuoteEvent('quick start', 'collapse - dismiss');
  };

  return (
    <>
      <div className="list-group-item-head flex-x gap-2">
        <button
          onClick={handleHeaderToggle}
          className="btn btn-lg btn-icon-start btn-link flex-grow-1 flex-x justify-content-start py-12px"
          type="button"
          aria-expanded={opened}
          aria-controls={collapseId}
        >
          <i
            aria-hidden="true"
            className={`icon icon-outlined text-secondary collapse-icon${opened ? ' is-open' : ''}`}
          >
            keyboard_arrow_down
          </i>
          <FormattedMessage id="smartQuote.quickStart.title" defaultMessage="Quick Start" />
        </button>
        {opened && (
          <button
            onClick={handleDismissToggle}
            className="btn btn-sm btn-link btn-dismiss"
            aria-expanded={opened}
            aria-controls={collapseId}
          >
            <FormattedMessage id="dismiss" defaultMessage="Dismiss" />
          </button>
        )}
      </div>

      <Collapse in={opened}>
        <div id={collapseId} className="grid gap-3 pb-3">
          <CopyCard className="g-col-4" />
          <DragDropCard className="g-col-4" />
          <ChatCard className="g-col-4" />
        </div>
      </Collapse>
    </>
  );
}
